module.exports = __webpack_public_path__ + "static/media/class-1.1a10ea44.jpeg";